import React from 'react';
import styled from 'styled-components';
import { useRouter } from 'found';

import { routes } from '../../routes';
import { MainMenu } from '../../components/menus/MainMenu/MainMenu';
import { MenuItem } from '../../components/menus/MainMenu/MenuItem';
import Spacer from '../../components/Spacer';
import {
  faCog,
  faExternalLinkAlt,
  faPlug,
} from '@fortawesome/free-solid-svg-icons';
import ContentCenterer from '../../components/ContentCenterer';

const PageSplitter = styled.div`
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const Content = styled.div`
  padding: 0px 0px;
  flex: 1;
  display: flex;
  margin-top: 77px;
`;

const ManagerText = styled.div`
  display: flex;
  align-items: center;
  margin-right: 50px;
  font-size: 14px;
  font-weight: 600;
`;

const DocsButton = styled.div`
  margin-left: auto;
`;

type Props = {
  children?: React.ReactNode;
};

function ManagerMenuWrapper({ children }: Props) {
  const { router, match } = useRouter();

  const isSelected = (routeMatch: string[]): boolean => {
    const { routes } = match;
    const currentRouter = routes[routes.length - 1];
    if (!currentRouter.path) {
      return false;
    }

    for (let i = 0; i < routeMatch.length; i++) {
      if (currentRouter.path.includes(routeMatch[i])) {
        return true;
      }
    }

    return false;
  };

  return (
    <>
      <MainMenu>
        <ManagerText>API Manager</ManagerText>
        <MenuItem
          fontawesomeIcon={{ icon: faPlug, color: '#5c6ef8' }}
          selected={isSelected([
            routes.apis,
            routes.createAPI,
            routes.createCharge,
            routes.api,
          ])}
          onClick={() => router.push(routes.apis)}
        >
          APIs
        </MenuItem>
        <Spacer horizontal spacing={2} />
        <MenuItem
          fontawesomeIcon={{ icon: faCog, color: '#5c6ef8' }}
          selected={isSelected([routes.merchantBilling])}
          onClick={() => router.push(routes.merchantBilling)}
        >
          Billing
        </MenuItem>
        <DocsButton>
          <MenuItem
            fontawesomeIcon={{ icon: faExternalLinkAlt, color: '#5c6ef8' }}
            selected={false}
            onClick={() => window.open('https://partner.paypi.dev', '_blank')}
            selectable={false}
          >
            Docs
          </MenuItem>
        </DocsButton>
      </MainMenu>
      <ContentCenterer>
        <PageSplitter>
          <Content>{children}</Content>
        </PageSplitter>
      </ContentCenterer>
    </>
  );
}

export default ManagerMenuWrapper;
